
import { useState, useEffect, useRef } from "react"
import { Link } from "react-router-dom"
import { getAuth, signOut } from "firebase/auth"
import { useNavigate } from "react-router-dom"
import { ref, onValue, auth, db, } from "../Firebase/firebase-config"
import { getDatabase, update } from "firebase/database"
import UserNotifications from "../Notification/UserNotifications"
import { onAuthStateChanged } from "firebase/auth"
import { LayoutDashboard, Search, Bell, Clock, User, MenuIcon, X, Tag, HelpCircle, LogOut } from "lucide-react"
import "./Navbar.css"
import { FaBuilding, FaUsers } from "react-icons/fa"
import { useAccount } from "../context/AccountContext";
import { useCurrentUid } from "../hooks/useCurrentUid";  // ← NEW IMPORT
import { remove } from "firebase/database";

const Navbar = () => {
  const navigate = useNavigate()
  const [companyName, setCompanyName] = useState(null)
  const [alarms, setAlarms] = useState([])
  const [newAlarms, setNewAlarms] = useState(false)
  const [searchQuery, setSearchQuery] = useState("")
  const [searchVisible, setSearchVisible] = useState(false)
  const [isAuthenticated, setIsAuthenticated] = useState(false)
  const [userUid, setUserUid] = useState("")
  const [showNotifications, setShowNotifications] = useState(false)
  const [unseenCount, setUnseenCount] = useState(0)
  // const [currentUid, setUserId] = useState(null)
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
  const [showUserDropdown, setShowUserDropdown] = useState(false)
  const [hasNewOffers, setHasNewOffers] = useState(false);
  const { currentAccount, accounts, switchAccount, reload } = useAccount();
  const [showAccountSwitcher, setShowAccountSwitcher] = useState(false);
  const [switching, setSwitching] = useState(false);


  const [error, setError] = useState("")
  const notificationRef = useRef(null)
  const userDropdownRef = useRef(null)
  const currentUid = useCurrentUid();


  // Close dropdowns when clicking outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (notificationRef.current && !notificationRef.current.contains(event.target)) {
        setShowNotifications(false);
      }
      if (userDropdownRef.current && !userDropdownRef.current.contains(event.target)) {
        setShowUserDropdown(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Company Name (from current selected account)
  useEffect(() => {
    if (currentAccount?.company_name) {
      setCompanyName(currentAccount.company_name);
    }
  }, [currentAccount]);

  // Delete Firm
  const handleDeleteFirm = async (uid) => {
    if (!window.confirm("Delete this firm permanently? This cannot be undone.")) return;
    try {
      await remove(ref(db, `profileDashboard/${uid}`));
      await reload();
      if (currentAccount?.uid === uid) {
        switchAccount(getAuth().currentUser.uid);
      }
    } catch (err) {
      alert("Failed to delete firm");
    }
  };

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        setIsAuthenticated(true);
        setUserUid(user.uid);
      } else {
        setIsAuthenticated(false);
        setUserUid("");
      }
    });

    return () => unsubscribe();
  }, []);

  const handleSearchToggle = () => {
    setSearchVisible(!searchVisible);
  };

  useEffect(() => {
    if (currentUid) {
      setUnseenCount(0);
      fetchUnseenNotifications(currentUid);
    }
  }, [currentUid]);

  useEffect(() => {
    if (!currentUid) return;

    const offersRef = ref(db, "offers");
    const viewedRef = ref(db, `user_viewed_offers/${currentUid}`);

    let offersData = {};
    let viewedData = {};

    const updateHasNew = () => {
      let hasNew = false;
      Object.keys(offersData).forEach(brand => {
        Object.keys(offersData[brand]).forEach(offerId => {
          const key = `${brand}-${offerId}`;
          if (!viewedData[key]) {
            hasNew = true;
          }
        });
      });
      setHasNewOffers(hasNew);
    };

    const unsubOffers = onValue(offersRef, (snapshot) => {
      offersData = snapshot.val() || {};
      updateHasNew();
    });

    const unsubViewed = onValue(viewedRef, (snapshot) => {
      viewedData = snapshot.val() || {};
      updateHasNew();
    });

    return () => {
      unsubOffers();
      unsubViewed();
    };
  }, [currentUid]);

  useEffect(() => {
    if (!currentUid) return;

    const db = getDatabase();
    const alarmsRef = ref(db, `alt_alarm/${currentUid}`);

    const unsubscribe = onValue(alarmsRef, (snapshot) => {
      if (snapshot.exists()) {
        const alarmsData = snapshot.val();
        const alarmList = Object.entries(alarmsData).map(([alarmId, alarm]) => ({
          alarmId,
          ...alarm,
        }));
        setAlarms(alarmList);

        const hasNew = alarmList.some((alarm) => alarm.isNew);
        setNewAlarms(hasNew);
      } else {
        setAlarms([]);
        setNewAlarms(false);
      }
    });

    return () => unsubscribe();
  }, [currentUid]);

  const handleAlarmClick = async () => {
    if (!currentUid) return;

    const db = getDatabase();
    const alarmsRef = ref(db, `alt_alarm/${currentUid}`);

    const updates = {};
    alarms.forEach((alarm) => {
      updates[`${alarm.alarmId}/isNew`] = false;
    });

    await update(alarmsRef, updates);
    setNewAlarms(false);
  };







  // searchbar functions
  const pages = [
    { name: "Cement Order", path: "/dashboard/product-order" },
    { name: "Ultratech Cement", path: "/dashboard/product-order" },
    { name: "Shree Cement", path: "/dashboard/product-order" },
    { name: "JSW Cement", path: "/dashboard/product-order" },
    { name: "JK Super Cement", path: "/dashboard/product-order" },
    { name: "ACC Cement", path: "/dashboard/product-order" },
    { name: "Ambuja Cement", path: "/dashboard/product-order" },
    { name: "Pending Order", path: "/dashboard/order-status" },
    { name: "UnderLoading Order", path: "/dashboard/order-status" },
    { name: "Dispatch Order", path: "/dashboard/order-status" },
    { name: "Paused Order", path: "/dashboard/order-status" },
    { name: "Continued Order", path: "/dashboard/order-status" },
    { name: "Completed Order", path: "/dashboard/order-status" },
    { name: "Realtime Tracking", path: "/dashboard/order-status" },
    { name: "Add Payment", path: "/dashboard/order-status" },
    { name: "QuoteRequest", path: "/dashboard/quote-request" },
    { name: "My Orders", path: "/dashboard/order-status" },
    { name: "Alert", path: "/dashboard/alt-alarm" },
    { name: "Offers", path: "/dashboard/newoffers" },
    { name: "Query", path: "/dashboard/new-query" },
    { name: "NewProduct Offer", path: "/dashboard/newSupplier-products" },
    { name: "Finance", path: "/dashboard/finance" },
    { name: "Loan", path: "/dashboard/finance" },
    { name: "Loan", path: "/dashboard/finance" },
    { name: "Contact Support", path: "/dashboard/contact-us" },
    { name: "Loan History", path: "/dashboard/loan-history" },
    { name: "Alarm", path: "/dashboard/alt-alarm" },
    { name: "Previous Orders", path: "/dashboard/previous-orders" },
    { name: "Steel Order", path: "/dashboard/product-order" },
    { name: "Machinery Order", path: "/dashboard/product-order" },
    { name: "Purchase Order (PO)", path: "/dashboard/PO" },
    { name: "New Code", path: "/dashboard/documents" },
    { name: "Documents", path: "/dashboard/documents" },
    { name: "Stock Status", path: "/dashboard/stock-status" },
    { name: "RateHistory", path: "/dashboard/rate-history" },
    { name: "Transport Goods", path: "/dashboard/transport-goods" },
  ]

  const filteredPages = pages
    .filter((page) => page.name.toLowerCase().includes(searchQuery.toLowerCase()))
    .filter(
      (page, index, self) =>
        index === self.findIndex((p) => p.path === page.path)
    );


  // Handle search and navigate to the selected page
  const handleSearchSelect = (path) => {
    navigate(path)
    setSearchQuery("")
    setMobileMenuOpen(false)
  }

  const handleLogout = () => {
    const auth = getAuth()
    signOut(auth)
      .then(() => {
        setError("");
        navigate("/login")
      })
      .catch((error) => {
        console.error("Error during sign out:", error)
      })
  }

  // Handle Enter key press
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault()
      if (filteredPages.length > 0) {
        handleSearchSelect(filteredPages[0].path)
      } else {
        alert("No matching results found")
      }
    }
  }

  useEffect(() => {
    // Get current user ID
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        fetchUnseenNotifications(currentUid);
      }
    })
    return () => unsubscribe()
  }, [currentUid])
  useEffect(() => {
    if (!currentUid) return;

    const offersRef = ref(db, "offers");
    const viewedRef = ref(db, `user_viewed_offers/${currentUid}`);

    let offersData = {};
    let viewedData = {};

    const updateHasNew = () => {
      let hasNew = false;
      Object.keys(offersData).forEach(brand => {
        Object.keys(offersData[brand]).forEach(offerId => {
          const key = `${brand}-${offerId}`;
          if (!viewedData[key]) {
            hasNew = true;
          }
        });
      });
      setHasNewOffers(hasNew);
    };

    const unsubOffers = onValue(offersRef, (snapshot) => {
      offersData = snapshot.val() || {};
      updateHasNew();
    });

    const unsubViewed = onValue(viewedRef, (snapshot) => {
      viewedData = snapshot.val() || {};
      updateHasNew();
    });

    return () => {
      unsubOffers();
      unsubViewed();
    };
  }, [currentUid, db]);
  // Fix the notification count issue in fetchUnseenNotifications function
  const fetchUnseenNotifications = (uid) => {
    const db = getDatabase()

    const notificationTypes = [
      "Order Dispatch",
      "Query Response",
      "Negotiation Response",
      "Quotation Response",
      "Raised Issues",
      "transportGoods",
      "Steel Orders",
      "machinery orders",
      "Low Balance",
      "Rate Response",
      "Refund Added",
      "Missing_Docs",
      "PO_Alerts",
      "New Code",
      "Partner-Management",
      "StockStatus"
    ]

    // Reset unseen count before fetching
    setUnseenCount(0)

    // Create a counter to track total unseen notifications
    let totalUnseen = 0

    // Fetch unseen notifications from standard nodes
    notificationTypes.forEach((type) => {
      const notificationsRef = ref(db, `user_notifications/${type}/${uid}`)

      onValue(notificationsRef, (snapshot) => {
        if (snapshot.exists()) {
          const notifications = snapshot.val()
          const unseenCount = Object.values(notifications).filter((notif) => !notif.seen && !notif.clicked).length

          totalUnseen += unseenCount
          setUnseenCount(totalUnseen)

          // Auto-show notifications when new ones arrive
          if (unseenCount > 0) {
            setShowNotifications(true)
          }
        }
      })
    })

    // Fetch unseen NewProduct notifications (stored under multiple supplierIds)
    const newProductRef = ref(db, `user_notifications/NewProduct`)

    onValue(newProductRef, (snapshot) => {
      if (snapshot.exists()) {
        const newProductData = snapshot.val()
        let unseenNewProductCount = 0

        Object.entries(newProductData).forEach(([supplierId, supplierNotifications]) => {
          Object.values(supplierNotifications).forEach((notif) => {
            if (!notif.seen && !notif.clicked) {
              unseenNewProductCount += 1
            }
          })
        })

        totalUnseen += unseenNewProductCount
        setUnseenCount(totalUnseen)

        // Auto-show notifications when new ones arrive
        if (unseenNewProductCount > 0) {
          setShowNotifications(true)
        }
      }
    })

    // Fetch unseen BrandRates notifications
    const brandRatesRef = ref(db, `user_notifications/BrandRates`)

    onValue(brandRatesRef, (snapshot) => {
      if (snapshot.exists()) {
        const brandRatesData = snapshot.val()
        let unseenBrandRatesCount = 0

        Object.entries(brandRatesData).forEach(([supplierId, supplierNotifications]) => {
          Object.values(supplierNotifications).forEach((notif) => {
            if (!notif.seen && !notif.clicked) {
              unseenBrandRatesCount += 1
            }
          })
        })

        totalUnseen += unseenBrandRatesCount
        setUnseenCount(totalUnseen)

        // Auto-show notifications when new ones arrive
        if (unseenBrandRatesCount > 0) {
          setShowNotifications(true)
        }
      }
    })
  }

  const markNotificationsAsSeen = () => {
    if (currentUid) {
      const db = getDatabase()

      const notificationTypes = [
        "Order Dispatch",
        "Query Response",
        "Negotiation Response",
        "Quotation Response",
        "Raised Issues",
        "transportGoods",
        "Steel Orders",
        "machinery orders",
        "Low Balance",
        "Rate Response",
        "Refund Added",
        "Missing_Docs",
        "PO_Alerts",
        "New Code",
        "Partner-Management",
        "StockStatus"
      ]

      // Mark standard notifications as seen
      notificationTypes.forEach((type) => {
        const notificationsRef = ref(db, `user_notifications/${type}/${currentUid}`)

        onValue(notificationsRef, (snapshot) => {
          if (snapshot.exists()) {
            const notifications = snapshot.val()
            Object.keys(notifications).forEach((key) => {
              if (!notifications[key].seen) {
                const notificationRef = ref(db, `user_notifications/${type}/${currentUid}/${key}`)
                update(notificationRef, { seen: true })
              }
            })
          }
        })
      })

      // Mark NewProduct notifications as seen (multiple supplier IDs)
      const productRef = ref(db, `user_notifications/NewProduct`)

      onValue(productRef, (snapshot) => {
        if (snapshot.exists()) {
          const brandRatesData = snapshot.val()

          Object.entries(brandRatesData).forEach(([supplierId, supplierNotifications]) => {
            Object.keys(supplierNotifications).forEach((key) => {
              if (!supplierNotifications[key].seen) {
                const notificationRef = ref(db, `user_notifications/NewProduct/${supplierId}/${key}`)
                update(notificationRef, { seen: true })
              }
            })
          })
        }
      })

      // Mark BrandRates notifications as seen (multiple supplier IDs)
      const brandRatesRef = ref(db, `user_notifications/BrandRates`)

      onValue(brandRatesRef, (snapshot) => {
        if (snapshot.exists()) {
          const brandRatesData = snapshot.val()

          Object.entries(brandRatesData).forEach(([supplierId, supplierNotifications]) => {
            Object.keys(supplierNotifications).forEach((key) => {
              if (!supplierNotifications[key].seen) {
                const notificationRef = ref(db, `user_notifications/BrandRates/${supplierId}/${key}`)
                update(notificationRef, { seen: true })
              }
            })
          })
        }
      })
    }
  }

  useEffect(() => {
    if (currentUid) {
      fetchUnseenNotifications(currentUid)
    }
  }, [currentUid])

  // alarm functionality
  useEffect(() => {
    const auth = getAuth()
    const db = getDatabase()

    const unsubscribeAuth = onAuthStateChanged(auth, (user) => {
      if (user) {
        const userRef = ref(db, `profileDashboard/${user.uid}`)
        onValue(userRef, (snapshot) => {
          if (snapshot.exists()) {
            const userData = snapshot.val()
            setCompanyName(userData.company_name || null)
          }
        })
      } else {
        setCompanyName(null)
      }
    })

    return () => unsubscribeAuth()
  }, [])

  useEffect(() => {
    if (!currentUid) return;

    const db = getDatabase();
    const alarmsRef = ref(db, `alt_alarm/${currentUid}`);

    const unsubscribe = onValue(alarmsRef, (snapshot) => {
      if (snapshot.exists()) {
        const alarmsData = snapshot.val();
        const alarmList = Object.entries(alarmsData).map(([alarmId, alarm]) => ({
          alarmId,
          ...alarm,
        }));
        setAlarms(alarmList);

        const hasNew = alarmList.some((alarm) => alarm.isNew);
        setNewAlarms(hasNew);
      } else {
        setAlarms([]);
        setNewAlarms(false);
      }
    });

    return () => unsubscribe();
  }, [currentUid]);

  // const handleAlarmClick = async () => {
  //   if (!currentUid) return;

  //   const db = getDatabase();
  //   const alarmsRef = ref(db, `alt_alarm/${currentUid}`);

  //   const updates = {};
  //   alarms.forEach((alarm) => {
  //     updates[`${alarm.alarmId}/isNew`] = false;
  //   });

  //   await update(alarmsRef, updates);
  //   setNewAlarms(false);
  // };

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen)
  }

  const handleNotificationClick = () => {
    if (unseenCount > 0) {
      markNotificationsAsSeen()
      setUnseenCount(0)
    }
    setShowNotifications(!showNotifications)
  }

  const handleUserIconClick = () => {
    setShowUserDropdown(!showUserDropdown)
  }

  const handleNavLinkClick = (path) => {
    navigate(path)
    setMobileMenuOpen(false)
  }

  return (
    <div className="navbar-wrapper">
      <nav className="modern-navbar">
        <div className="navbar-container">
          {/* Logo/Brand */}
          <div
            className="navbar-brand-container"
            onClick={() => {
              navigate("/dashboard")
            }}
          >
            <LayoutDashboard className="nav-icon dashboard-icon" />
            <h2 className="navbar-brand mt-2" style={{ fontSize: '1.5rem', color: '#fff' }}>Dashboard</h2>
          </div>

          {/* Mobile Menu Toggle */}
          <div className="mobile-toggle" onClick={toggleMobileMenu}>
            {mobileMenuOpen ? <X className="h-6 w-6" /> : <MenuIcon className="h-6 w-6 toggle-icon" />}
          </div>

          {/* Search Bar (centered) */}
          <div className="search-container">
            <div className="search-input-wrapper">
              <input
                className="search-input"
                type="search"
                placeholder="Search.........."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                onKeyDown={handleKeyDown}
              />
              <Search className="search-icon" />
            </div>
            {searchQuery && (
              <ul className="search-results">
                {filteredPages.length > 0 ? (
                  filteredPages.map((page) => (
                    <li className="search-result-item" key={page.path} onClick={() => handleSearchSelect(page.path)}>
                      {page.name}
                    </li>
                  ))
                ) : (
                  <li className="search-result-item not-found">No matching results found</li>
                )}
              </ul>
            )}
          </div>

          {/* Right Side Icons */}
          <div className="navbar-actions">
            {/* Notifications */}
            <div className="notification-container" ref={notificationRef}>
              <div className="notification-trigger" onClick={handleNotificationClick}>
                <div className="icon-container">
                  <Bell className="nav-icon notification-icon" />
                  <span className="icon-label">Notifications</span>
                </div>
                {unseenCount > 0 && (
                  <span className="notification-indicator pulse">{unseenCount > 9 ? "9+" : unseenCount}</span>
                )}
              </div>
              {showNotifications && (
                <div className="notification-dropdown">
                  <div className="notification-header">

                    {unseenCount > 0 && <span className="notification-count">{unseenCount} new</span>}
                  </div>
                  <div className="notification-content">
                    <UserNotifications onClose={() => setShowNotifications(false)} />
                  </div>
                </div>
              )}
            </div>

            {/* Alarm */}
            <div className="alarm-container">
              <Link to="/dashboard/alt-alarm" className="alarm-trigger" onClick={handleAlarmClick}>
                <div className="icon-container">
                  <Clock className="nav-icon alarm-icon" />
                  <span className="icon-label">Alerts</span>
                </div>
                {newAlarms && <span className="alarm-indicator pulse"></span>}
              </Link>
            </div>

            {/* New Offers */}
            <Link className="new-offers-link" to="/dashboard/newoffers">
              <div className={`icon-container ${hasNewOffers ? "new-offers-shine" : ""}`}>
                <Tag className="nav-icon new-offers-icon" />
                <span className="icon-label">New Offers</span>
              </div>
            </Link>

            {/* User Profile */}
            <div className="user-profile-container" ref={userDropdownRef}>
              <div className="user-profile-trigger" onClick={handleUserIconClick}>
                <div className="icon-container">
                  <User className="nav-icon user-icon" />
                  <span className="icon-label">Profile</span>
                </div>
              </div>
              {showUserDropdown && (
                <div className="user-dropdown">
                  <div className="user-dropdown-header">
                    <span className="user-greeting">Hello, User!</span>
                  </div>
                  <Link className="dropdown-item" to="/profile">
                    <User className="w-5 h-5" />
                    {"  "}   Profile
                  </Link>
                  {currentAccount?.type === "main" && (
                    <Link className="dropdown-item" to="/dashboard/partner-management">
                      <FaUsers className="w-5 h-5" />
                      {"  "} Partner Management
                    </Link>
                  )}
                  <div
                    className="dropdown-item"
                    onClick={() => setShowAccountSwitcher(true)}
                  >
                    <FaUsers className="w-5 h-5" />
                    {"  "} Switch Account
                  </div>

                  {currentAccount?.type === "main" && (
                    <Link className="dropdown-item" to="/add-firms">
                      <FaBuilding className="w-5 h-5" />
                      {"  "} Add Firms
                    </Link>
                  )}

                  <Link className="dropdown-item" to="/dashboard/need-help">
                    <HelpCircle className="w-5 h-5" />
                    {"  "}  Help
                  </Link>
                  <div className="dropdown-item" onClick={handleLogout}>
                    <LogOut className="w-5 h-5" />
                    {"  "}  Logout
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        {showAccountSwitcher && (
          <div className="account-switcher-overlay" onClick={() => setShowAccountSwitcher(false)}>
            <div className="account-switcher-panel" onClick={(e) => e.stopPropagation()}>
              <h3 className="switcher-title">Switch Account</h3>

              {accounts.map((acc) => (
                <div
                  key={acc.uid}
                  className={`switcher-account-item ${acc.uid === currentAccount?.uid ? "active" : ""}`}
                  onClick={async () => {
                    setSwitching(true);            // start loader
                    await switchAccount(acc.uid);  // switch
                    setShowAccountSwitcher(false); // close panel
                    setSwitching(false);           // end loader
                  }}

                >
                  <div className="switcher-avatar">{acc.name?.[0] || "A"}</div>
                  <div className="switcher-info">
                    <div className="switcher-name">{acc.name || "Main Account"}</div>
                    {acc.uid === currentAccount?.uid && <div className="switcher-current">Current</div>}
                  </div>
                </div>
              ))}

              {currentAccount?.type === "main" && (
                <Link className="switcher-add-firm" to="/add-firms">
                  + Add Firm
                </Link>
              )}
            </div>
          </div>
        )}
        {switching && (
          <div className="switch-loader-overlay">
            <div className="switch-loader"></div>
          </div>
        )}



        {/* Mobile Menu */}
        <div className={`mobile-menu ${mobileMenuOpen ? "open" : ""}`}>
          <div className="mobile-search">
            <div className="search-input-wrapper">
              <input
                className="search-input"
                type="search"
                placeholder="Search.........."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                onKeyDown={handleKeyDown}
              />
              <Search className="search-icon" />
              {searchQuery && (
                <ul className="search-results">
                  {filteredPages.length > 0 ? (
                    filteredPages.map((page) => (
                      <li className="search-result-item" key={page.path} onClick={() => handleSearchSelect(page.path)}>
                        {page.name}
                      </li>
                    ))
                  ) : (
                    <li className="search-result-item not-found">No matching results found</li>
                  )}
                </ul>
              )}
            </div>
          </div>
          <div className="mobile-actions">
            <div className="mobile-action-item" onClick={() => handleNavLinkClick("/dashboard/newoffers")}>
              <Tag className="w-5 h-5" />
              New Offers
            </div>
            <div className="mobile-action-item" onClick={() => handleNavLinkClick("/profile")}>
              <User className="w-5 h-5" />
              Profile
            </div>
            {currentAccount?.type === "main" && (
              <div className="mobile-action-item" onClick={() => handleNavLinkClick("/dashboard/partner-management")}>
                <FaUsers className="w-5 h-5" />
                Partner Management
              </div>
            )}
            <div
              className=" mobile-action-item"
              onClick={() => setShowAccountSwitcher(true)}
            >
              <FaUsers className="w-5 h-5 " />
              {"  "} Switch Account
            </div>

            {currentAccount?.type === "main" && (
              <Link className="mobile-action-item" to="/add-firms">
                <FaBuilding className="w-5 h-5" />
                {"  "} Add Firms
              </Link>
            )}
            <div className="mobile-action-item" onClick={() => handleNavLinkClick("/dashboard/need-help")}>
              <HelpCircle className="w-5 h-5" />
              Help
            </div>
            <div className="mobile-action-item" onClick={handleLogout}>
              <LogOut className="w-5 h-5" />
              Logout
            </div>
          </div>
        </div>
      </nav>
    </div>
  )
}

export default Navbar

